import { css } from "@emotion/react";

export const MFavouriteGamePageStyle = {
  self: css`
    /*  */
  `,

  listGame: css`
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 16px;
  `,

  bodyEmpty: css`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 50px;
    width: 100%;
    min-height: 560px;
    padding: 15px;
    gap: 10px;

    img {
      object-fit: contain;
      height: 83px;
    }

    h3 {
      font-size: 22px;
      margin-top: 20px;
      font-family: inherit;
      font-weight: 500;
      line-height: 1.1;
      color: #bfbfbf;
      font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
    }

    span {
      color: #bfbfbf;
      font-size: 14px;
      text-align: center;
      font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
      line-height: 1.42857143;
    }
  `,
};
